import { Badge } from "@/components/ui/badge";

interface DiscrepancyStatusProps {
  status: string;
}

export const DiscrepancyStatus = ({ status }: DiscrepancyStatusProps) => {
  const getStatusLabel = (status: string) => {
    switch (status) {
      case "justified":
        return "Justifié";
      case "pending":
        return "En attente";
      case "salary_deduction":
        return "Retenue sur salaire";
      case "forgiven":
        return "Pardonné";
      default:
        return status;
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "justified":
        return "bg-green-100 text-green-800 border-green-800";
      case "pending":
        return "bg-yellow-100 text-yellow-800 border-yellow-800";
      case "salary_deduction":
        return "bg-orange-100 text-orange-800 border-orange-800";
      case "forgiven":
        return "bg-blue-100 text-blue-800 border-blue-800";
      default:
        return "bg-gray-100 text-gray-800 border-gray-800";
    }
  };

  return (
    <Badge variant="outline" className={`${getStatusColor(status)}`}>
      {getStatusLabel(status)}
    </Badge>
  );
};